"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Offer = void 0;
var common_1 = require("../common");
var ChangeCase = require("change-case");
var Offer = /** @class */ (function (_super) {
    __extends(Offer, _super);
    function Offer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Offer.defaultProps = function (type, name, owner) {
        return {
            id: ChangeCase.constant(owner) + ";;" + ChangeCase.constant(name),
            type: type,
            types: [],
            name: '',
            description: '',
            refs: [],
            media: null,
            invalid: false
        };
    };
    return Offer;
}(common_1.AbstractModel));
exports.Offer = Offer;
